<template>
    <div class="filter-dropdown" v-on-click-outside="close">
        <div class="filter-dropdown_title mb-1 pt-1 px-3" v-if="title" @click="isOpen = !isOpen">
            <small>{{ title }}</small>
        </div>
        <div class="filter-dropdown_selected pb-2 d-flex px-3 large fs-6" @click="isOpen = !isOpen">
            <span v-if="selectedLabel" class="me-2">
                <template v-if="!labelsTranslate">{{ selectedLabel }}</template>
                <template v-else>{{ $t(labelsTranslate  + '.' + selectedLabel) }}</template>
            </span>
            <span v-else class="me-2">{{ notSelectedLabel }}</span>
            <font-awesome-icon :icon="['fas', 'sort-down']" size="xs" />
        </div>
        <div class="filter-dropdown_items" v-show="isOpen">
            <div v-if="isSearch" class="filter-dropdown_item filter-dropdown_item__search px-3 py-2 d-flex justify-content-between align-items-center">
                <font-awesome-icon :icon="['fas', 'magnifying-glass']" />
                <input type="text" class="ms-2 form-control" v-model="searchField" ref="searchField">
            </div>
            <div class="filter-dropdown_item px-3 py-2 d-flex justify-content-between align-items-center"
                 v-for="item in items"
                 :class="{active: selectedValue === item.value, 'd-none': !search(item)}"
                 @click="select(item)" 
                 :key="item.value"
            >
                <span v-if="!labelsTranslate">{{ item.label }}</span>
                <span v-else>{{ $t(labelsTranslate  + '.' + item.label) }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { vOnClickOutside } from '@vueuse/components'
import screenMixin from 'mixins/screen'

export default {
    name: 'FilterdDropdown',
    emits: ['update:items', 'update:modelValue'],
    directives: {
        onClickOutside: vOnClickOutside
    },
    props: {
        items: {
            type: Array,
            default: () => []
        },
        modelValue: {
            type: Number,
            default: null
        },
        title: {
            type: String,
            default: null
        },
        notSelectedLabel: {
            type: String,
            default: 'Select value'
        },
        isSearch: {
            type: Boolean,
            default: true
        },
        labelsTranslate: {
            default: false
        }
    },
    data() {
        return {
            isMobile: false,
            isOpen: false,
            selectedLabel: null,
            selectedValue: null,
            searchField: '',
        }
    },
    methods: {
        select(item) {
            this.searchField = '';
            this.selectedLabel = item.label;
            this.selectedValue = item.value;
            this.$emit('update:modelValue', this.selectedValue);
            this.isOpen = false;
        },
        selectByValue(value) {
            if(value === null){
                this.selectedLabel = null;
                this.selectedValue = null;
            }else{
                const item = this.items.find(item => item.value == value);
                this.select(item);
            }
        },
        search(item) {
            if(this.searchField == '')
                return true;
            return item.label.toLowerCase().indexOf(this.searchField.toLowerCase()) !== -1;
        },
        close() {
            this.isOpen = false;
        }
    },
    watch: {
        isOpen(newVal) {
            if(!this.isSearch)
                return false;

            const self = this;
            if(newVal && !self.isMobile)
                setTimeout(() => self.$refs.searchField.focus(), 100);
            else
                this.searchField = '';
        },
        modelValue(newVal){
            this.selectByValue(newVal)
        },
        items(items){
            this.selectByValue(items[0].value);
        }
    },
    mixins: [
        screenMixin
    ],
    beforeMount() {
        const self = this;
        window.addEventListener('resize', function(){
            self.isMobile = self.isBreakpoint('xs') || self.isBreakpoint('sm');
        });
        self.isMobile = self.isBreakpoint('xs') || self.isBreakpoint('sm');
    },
}
</script>

<style scoped>
    .filter-dropdown .form-control{
        box-shadow: none !important;
        border: none !important;
        padding: 0 !important;
    }
    .filter-dropdown_selected svg{
        margin-top: 3px;
    }
    .filter-dropdown{
        position: relative;
        cursor: pointer;
    }
    .filter-dropdown_title, .filter-dropdown_item__search svg{
        color: var(--bs-gray-500);
    }
    .filter-dropdown_items{
        background: #fff;
        position: absolute;
        left: 0;
        right: 0;
        border-radius: 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

        max-height: calc(38px * 10);
        overflow: auto;
        z-index: 100;
    }
    .filter-dropdown_item{
        border-bottom: 1px solid rgba(255, 255, 255, .1);
    }
    .filter-dropdown_item:hover:not(.filter-dropdown_item__search){
        background: var(--bs-primary) !important;
        color: var(--bs-white) !important;
    }
    .filter-dropdown_items > div:not(:last-child){
        border-bottom: 1px solid rgba(0, 0, 0, .06);
    }
</style>

<style>
.dark-mode .filter-dropdown_items .form-control,
.dark-mode .filter-dropdown_items{
    background-color: var(--bs-gray-700) !important;
}
</style>
